import React from "react";
import moment from "moment";
import { mdiCheck, mdiExclamation, mdiMinus, mdiPlay } from "@mdi/js";
import MdiIcon from "../../components/device/app/MdiIcon";
import { TYPE_LABELS, runDevicesText, runSourceText, runWhenText } from "../../automation/format";
import { TYPE_LOOK } from "../../automation/look";

// What a run looks like in lists, as the app's app/screens/Automation/RunViews.js.

// Enough of the automation to run it again from one of its runs.
export const automationOfRun = (run) => ({ id: run.automationId, name: run.name, type: run.type });

// The type's icon in a tinted circle.
export const TypeIcon = ({ type, size = 34 }) => {
  const look = TYPE_LOOK[type] || TYPE_LOOK.tap;
  return (
    <span className="hx-auto-type" style={{ "--hx-auto-type": look.color, width: size, height: size }} aria-hidden="true">
      <MdiIcon path={look.icon} size={Math.round(size * 0.55)} />
    </span>
  );
};

// ✓ ran, ! failed, – skipped (an "only if" that didn't hold isn't a failure).
const STATUS_LOOK = {
  ok: { icon: mdiCheck, label: "Ran" },
  failed: { icon: mdiExclamation, label: "Failed" },
  skipped: { icon: mdiMinus, label: "Skipped" },
};

export const StatusBadge = ({ run, small = false }) => {
  const look = STATUS_LOOK[run.status] || STATUS_LOOK.ok;
  return (
    <span className={`hx-auto-badge is-${run.status || "ok"} ${small ? "is-small" : ""}`} title={look.label}>
      <MdiIcon path={look.icon} size={small ? 12 : 14} title={look.label} />
    </span>
  );
};

// One card in Home's Recent Automations row.
export const RecentRunCard = ({ run, lookup, onOpen, onRun }) => {
  const devices = runDevicesText(run, lookup);
  return (
    <article className="hx-auto-recent">
      <div className="hx-auto-recent-top">
        <TypeIcon type={run.type} />
        {onRun ? (
          <button type="button" className="hx-auto-recent-play" onClick={onRun} aria-label={`Run ${run.name}`}>
            <MdiIcon path={mdiPlay} size={16} />
          </button>
        ) : (
          <StatusBadge run={run} />
        )}
      </div>
      <h3 className="hx-auto-recent-name">
        <button type="button" className="hx-auto-open" onClick={onOpen}>
          {run.name}
        </button>
      </h3>
      <p className="hx-auto-recent-sub">{[TYPE_LABELS[run.type], devices].filter(Boolean).join(" · ")}</p>
      <p className={`hx-auto-recent-sub ${run.status === "failed" ? "is-failed" : ""}`}>{runWhenText(run)}</p>
    </article>
  );
};

// One run in a history list: what ran, what started it, when, and how it went.
export const RunRow = ({ run, onOpen }) => {
  const failed = run.status === "failed";
  const skipped = run.status === "skipped";
  const Tag = onOpen ? "button" : "div";
  return (
    <li>
      <Tag type={onOpen ? "button" : undefined} className="hx-auto-runrow" onClick={onOpen}>
        <TypeIcon type={run.type} size={32} />
        <span className="hx-auto-runrow-text">
          <span className="hx-auto-runrow-name">{run.name}</span>
          <span className={`hx-auto-runrow-sub ${failed ? "is-failed" : ""}`}>
            {failed || skipped ? run.message || runSourceText(run) : runSourceText(run)}
          </span>
        </span>
        <span className="hx-auto-runrow-right">
          <time dateTime={run.at}>{moment(run.at).format("h:mm A")}</time>
          <StatusBadge run={run} small />
        </span>
      </Tag>
    </li>
  );
};
